import React from 'react';

import { cargoTrackingStrings, coopSites } from '@data/cargoTracking';
import {
  CargoCoop,
  DomesticTrackingDetailItem,
  TrackingDetailItem,
  TransportStatus,
} from '@models/TrackingData';
import { useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';
import clsx from 'clsx';

const strings = createStrings({
  ja: {
    here: 'こちら',
    getTrackingInfo: 'から運送会社の追跡ページをご確認いただけます。',
  },
});

export interface TrackingDetailItemNoteProps {
  statusName: TransportStatus;
  item: TrackingDetailItem | DomesticTrackingDetailItem;
}

export const TrackingDetailItemNote: React.FC<TrackingDetailItemNoteProps> = (props) => {
  const { item, statusName } = props;

  const classes = useCommonStyles();

  if (statusName === 'ドライバー情報・送り状') {
    if ('coop_name' in item) {
      const coopName = item.coop_name as CargoCoop;

      if (['チャータートラック', 'コンテナ'].includes(coopName)) {
        return <>{item.note || '-'}</>;
      }
      return (
        <>
          <a
            className={clsx(classes.link, classes.underline)}
            href={coopSites[coopName]}
            target="_blank"
            rel="noreferrer"
          >
            {strings.here}
          </a>
          {strings.getTrackingInfo}
        </>
      );
    }
  } else if (statusName === '国内配達中') {
    if ('coop_name' in item) {
      const coopName = item.coop_name as CargoCoop;

      if (coopName === 'チャータートラック') {
        return (
          <>
            {cargoTrackingStrings.carNo}: {item.car_no} {cargoTrackingStrings.carDriver}:{' '}
            {item.car_driver}
          </>
        );
      }

      if (coopName === 'コンテナ') {
        return (
          <>
            {item.coop_name}: {item.car_no} {cargoTrackingStrings.carDriver}: {item.car_driver}
          </>
        );
      }
      return (
        <>
          <a className={classes.link} href={coopSites[coopName]} target="_blank" rel="noreferrer">
            {item.coop_name}
          </a>{' '}
          {cargoTrackingStrings.coopTrackNo}: {item.coop_tracking_no}
        </>
      );
    }
  }

  return <>{item.note || '-'}</>;
};
